'use client'

import { setAgentDeployed } from '@/lib/features/agent/agentSlice'
import { clearMessages } from '@/lib/features/chats/chatSlice'
import { setShowAppPanel, setShowCustomizationPanel } from '@/lib/features/layoutSlice'
import { useAppDispatch } from '@/lib/hooks'
import { useEffect } from 'react'
import LandingPage from './landing/page'

export default function HomeWrapper() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(clearMessages())
    dispatch(setShowAppPanel(false))
    dispatch(setShowCustomizationPanel(false))
    dispatch(setAgentDeployed(false))
  }, [dispatch])

  return <LandingPage />
}
